import { apiCall, NEW_BE_API } from '../../utils/APIFunctions';

export function createUserGroup(params) {
  return apiCall(`${NEW_BE_API}/api/n1/usergroups/`,"post", JSON.stringify(params)); 
}

export function getUserGroups() {
  return apiCall(`${NEW_BE_API}/api/n1/usergroups`, "get");
}
  
export function removeUserGroup(groupId) {
  return apiCall(`${NEW_BE_API}/api/n1/usergroups/${groupId}`,"delete");
}
  
export function editUserGroup(params) {
  return apiCall(`${NEW_BE_API}/api/n1/usergroups/${params.groupId}`,"put", JSON.stringify({name: params.name}));
}
  
export function addUsersToGroup(params) {
  return apiCall(`${NEW_BE_API}/api/n1/usergroups/${params.groupId}/users`, "post", JSON.stringify({userIds: params.userIds}));
}
  
export function removeUserFromGroup(params) {
  return apiCall(`${NEW_BE_API}/api/n1/usergroups/${params.groupId}/user/${params.userId}`, "delete");
}

export function getInvoicingData(groupId) {
  return apiCall(`${NEW_BE_API}/api/n1/usergroups/${groupId}/invoicing-data`, "get");
}
